import { tDispatch } from "../store";
import { eUIActionTypes } from "./UITypes";

export const clearUIState = () => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.CLEAR_STATE,
		})
	}
}

export const setInited = () => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_INITED,
		})
	}
}

export const setIsChrRegistered = (state: boolean) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_IS_CHR_REGISTERED,
			payload: state
		})
	}
}

export const setIsOrderBookModalButtonsBlocked = (state: boolean) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_IS_ORDER_BOOK_MODAL_BUTTONS_BLOCKED,
			payload: state
		})
	}
}

export const setIsWrongNetwork = (state: boolean) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_IS_WRONG_NETWORK,
			payload: state
		})
	}
}

export const setIsPricesUpdating = (state: boolean) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_IS_PRICES_UPDATING,
			payload: state
		})
	}
}

export const setProvider = (state: any) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eUIActionTypes.SET_PROVIDER,
			payload: state
		})
	}
}